import Banner, { type BannerProps } from '@atlaskit/banner';
import { withChoreographedRender } from '@atlassian/jira-choreographer-services/src/withChoreographedRender.tsx';

export const ChoreographerBanner = withChoreographedRender<BannerProps>(Banner);
